<template>

    <div>

        <v-style v-if="width">
            .floorplan-modal .modal-wrapper .modal-container {
            max-width: {{this.width + "px"}};
            }
        </v-style>

        <div @click="active=true">
            <slot name="button"></slot>
        </div>

        <transition name="modal">

            <div class="modal-mask floorplan-modal" v-if="active">

                <div class="modal-wrapper">

                    <div class="modal-container floorplans" style="max-width: 600px;padding: 20px 30px;">

                        <button class="close-btn btn" @click="active=false">
                            <font-awesome-icon :icon="['fal', 'times']"  full-width></font-awesome-icon>
                        </button>

                        <div class="modal-header" style="padding:0;border-color:#ebebeb;">
                            <h2 style="margin-top:0">Floor Plans</h2>
                        </div>

                        <div class="modal-body" style="padding:15px 0;">

                            <div class="tabs">
                                <button class="tab btn" v-for="(plan,index) in floorplans" :key="index" @click="currentIndex = index" :class="{'active':currentIndex===index}" v-html="plan.title"></button>
                            </div>

                           <div v-for="(plan,index) in floorplans" :key="index" v-show="currentIndex===index">

                                <img :src="plan.media[0].original_url" alt="" class="img-fluid">

                                <div class="sqft" :class="plan.sfpos">
                                    {{plan.sqft}} sq. ft.
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </transition>


    </div>

</template>

<script>
//import { mapState, mapMutations } from 'vuex';

export default {
    name: "AccommodationsFloorplanModal",

    props: {
        floorplans: {
            type: Object|Array,
            required: false,
        },
        width: {
            type: Boolean,
        }
    },

    data() {
        return {
            active:false,
            currentIndex:0
        }
    },

    mounted() {

    },

    methods: {

        //close: function () { },

    },

    computed: {

        //...mapState({

        //loc: state => state.loc,

        //}),

    },

    watch: {
        //show:function(newValue){ }
    },

    //beforeDestroy: function () { }

}
</script>

<style scoped lang="scss">

</style>
